module.exports = __webpack_public_path__ + "static/media/play_arrow_white72deaf2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/play_arrow_white.svg
// module id = 1254
// module chunks = 0